// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"5d775898","74":"8780992f","142":"3f57903e","462":"fdb59a40","725":"cbd94f6e","844":"acf39096"}[chunkId] + ".chunk.js";
};